import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';
import withMessages from 'component-utilities/intl';

import ExportHeader from './Export/ExportHeader';
import styles from './Dropdowns.scss';

const BASE_KEY = 'components.dropdowns.export.views';

function component({ getMessage }) {
    return (<div
        className={styles['dropdown-export']}
        data-dropdown="export-loading"
    >
        <ExportHeader
            text={getMessage(`${BASE_KEY}.assets_selected.header`)}
        />
    </div>)
}

component.propTypes = {
    getMessage: PropTypes.func.isRequired,
};

const ExportLoadingDropdown = withMessages(component);
ExportLoadingDropdown.displayName = displayName('Dropdowns/ExportLoadingDropdown');

export default ExportLoadingDropdown;
